import Page from './components/Page'
import { HAPPINESS_PAGE } from './pages'

export default {
  [HAPPINESS_PAGE]: {
    path: '/reports/inbox/happiness',
    component: Page,
  },
}
